import { Sparkles, Zap, Lock } from 'lucide-react';
import { useLanguage } from '../../../../features/language/useLanguage';
import type { SubscriptionTier } from '../../../../services/subscriptionService';

/** Colored pill rendering a subscription tier (plus / basic / free). */
export function TierBadge({ tier }: { tier: SubscriptionTier }) {
  const { t } = useLanguage();
  if (tier === 'plus') {
    return (
      <span className="inline-flex items-center gap-1 rounded-md bg-amber-50 text-amber-800 ring-1 ring-inset ring-amber-200 px-2 py-0.5 text-xs font-semibold">
        <Sparkles className="h-3 w-3" />
        {t('subscription.tier.plus')}
      </span>
    );
  }
  if (tier === 'basic') {
    return (
      <span className="inline-flex items-center gap-1 rounded-md bg-sky-50 text-sky-700 ring-1 ring-inset ring-sky-200 px-2 py-0.5 text-xs font-semibold">
        <Zap className="h-3 w-3" />
        {t('subscription.tier.basic')}
      </span>
    );
  }
  return (
    <span className="inline-flex items-center gap-1 rounded-md bg-gray-100 text-gray-700 ring-1 ring-inset ring-gray-200 px-2 py-0.5 text-xs font-medium">
      <Lock className="h-3 w-3" />
      {t('subscription.tier.free')}
    </span>
  );
}
